import React from 'react';

/**
 * A recovery page for users to download files from previous assessments,
 * intended as a last resort for failed uploads.
 */

const FileRecoveryPage = () => {
  return (
    <div
      style={{
        textAlign: 'justify',
        margin: '20px auto',
        maxWidth: '600px',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white'
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          marginTop: '0'
        }}
      >
        File Recovery
      </h1>
      <p>
        On this page you can download all files for every previous assessment
      </p>
      <p>
        Please click the "Show Uploads" button on the top right corner to see
        the files that were previously uploaded to our platform.
      </p>
      <p>
        If you got access to this page as part of recovery process, and you have
        an assessment attempt UUID you can identify which of the files you need
        to download by the first part of the item name.
      </p>
      <p>
        After downloading the files, please contact support for further
        instructions
      </p>
    </div>
  );
};

export default FileRecoveryPage;
